var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useReducer, } from 'react';
var DEFAULT_CONTEXT = {
    subscribers: {
        'activate-row': [],
    },
    subscribe: function () { return undefined; },
    unsubscribe: function () { return undefined; },
};
var context = createContext(DEFAULT_CONTEXT);
var initialState = DEFAULT_CONTEXT.subscribers;
var subscribersStateReducer = function (state, action) {
    var _a, _b;
    var _c;
    switch (action.type) {
        case 'add':
            if ((_c = state[action.payload.name]) === null || _c === void 0 ? void 0 : _c.includes(action.payload.cb)) {
                return state;
            }
            return __assign(__assign({}, state), (_a = {}, _a[action.payload.name] = __spreadArray(__spreadArray([], (state[action.payload.name] || []), true), [
                action.payload.cb,
            ], false), _a));
        case 'remove':
            return __assign(__assign({}, state), (_b = {}, _b[action.payload.name] = (state[action.payload.name] || []).filter(function (s) { return s !== action.payload.cb; }), _b));
        case 'reset':
            return initialState;
        default:
            return state;
    }
};
var useWeeklyEventsInit = function () {
    var _a = useReducer(subscribersStateReducer, initialState), subscribers = _a[0], dispatch = _a[1];
    var handleEvent = useCallback(function (event) {
        var type = event.type;
        var callbacks = subscribers[type] || [];
        callbacks.forEach(function (callback) { return callback(event); });
    }, [subscribers]);
    var updateListeners = useCallback(function () {
        Object.keys(subscribers).forEach(function (name) {
            var eventName = name;
            // @ts-ignore
            window.removeEventListener(eventName, handleEvent);
            // @ts-ignore
            window.addEventListener(eventName, handleEvent);
        });
    }, [handleEvent, subscribers]);
    var subscribe = useCallback(function (name, callback) {
        dispatch({
            type: 'add',
            payload: {
                name: name,
                cb: callback,
            },
        });
    }, []);
    var unsubscribe = useCallback(function (name, callback) {
        dispatch({
            type: 'remove',
            payload: {
                name: name,
                cb: callback,
            },
        });
    }, []);
    var clearAllSubscribers = useCallback(function () {
        Object.keys(subscribers).forEach(function (name) {
            var eventName = name;
            // @ts-ignore
            window.removeEventListener(eventName, handleEvent);
            subscribers[eventName] = [];
        });
    }, [handleEvent, subscribers]);
    useEffect(function () {
        updateListeners();
        return function () {
            clearAllSubscribers();
        };
    }, [clearAllSubscribers, updateListeners]);
    return { subscribers: subscribers, subscribe: subscribe, unsubscribe: unsubscribe };
};
var WeeklyEventsProvider = function (_a) {
    var children = _a.children;
    return (_jsx(context.Provider, __assign({ value: useWeeklyEventsInit() }, { children: children }), void 0));
};
var useWeeklyEventsSubscriber = function () {
    var _a = useContext(context), subscribe = _a.subscribe, unsubscribe = _a.unsubscribe;
    return {
        subscribe: subscribe,
        unsubscribe: unsubscribe,
    };
};
var createEvent = function (name, detail) {
    return new CustomEvent(name, {
        detail: detail,
    });
};
var useWeeklyEventsDispatcher = function () {
    var dispatch = useCallback(function (name, detail) {
        var event = createEvent(name, detail);
        window.dispatchEvent(event);
        return event;
    }, []);
    return dispatch;
};
export { WeeklyEventsProvider, useWeeklyEventsDispatcher, useWeeklyEventsSubscriber, };
